import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterInterventions {
    phaseIds?: number[];
    page?: number;
    sort?: string;
    etats?: string[];
    chantierIds?: number[];
    id: string;
    mesInterventions?: boolean;
    dateDebutPeriodeRechercheParDate?: string;
    dateFinPeriodeRechercheParDate?: string;
    isBim?: boolean;
    adresseProjetIds?: number[];
}

class SuiviInterventionService {
    public async getSuiviInterventions(params: FilterInterventions, signal?: AbortSignal): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetNonPreventiveInterventionList(), { params, signal });
    }
    public async getIntervention(id: number): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetOneInterventions(id));
    }
    public async getRapportInfo(id: number) {
        return http.get(Routes.InterventionRoutes.GetRapportInfo(id));
    }
    public async getRapportPDF(id: number) {
        return http.get(Routes.InterventionRoutes.GetRapportPDF(), { params: { id }, responseType: 'arraybuffer' });
    }
    public async getListDemandeInterventionByNonPreventiveInterventionId(id: number): Promise<any> {
        return await http.get(Routes.InterventionRoutes.GetListDemandeInterventionByNonPreventiveInterventionId(id));
    }
    public async getExportXlsInterventions(params: FilterInterventions): Promise<any> {
        return http.get(Routes.InterventionRoutes.GetExportXlsInterventions(), { params, responseType: 'arraybuffer' });
    }
}

export default new SuiviInterventionService();
